// много закомментированных строк ибо возможно, что скрытый функционал вернется

import React from "react";
import { Alert, Button } from "antd";
// import classes from "./ProfessionalJudgment.module.css";
// import { CommentForm } from "../../../../UI_ITO/UI_ITOModuleCommentForm/CommentForm";
import { useParams } from "react-router-dom";
// import { useGetApplicationDataToBankQuery } from "../../../../store/api/applicationBankApi/applicationBank.api";
// import { useForm } from "antd/es/form/Form";
// import { APPLICATION_BANK_STATUS } from "../../../../utils/guards/ApplicationBankStatusGuard/types";
import { applicationBankDocumentsApi } from "../../../../services/documents/documents.api";
// import { useUpdateCreditWorthinessConclusionMutation } from "../../../../store/api/applicationBankApi/scoring.api";

// const { Text } = Typography;
const { downloadJudgment } = applicationBankDocumentsApi;

export const ProfessionalJudgment = () => {
  const { applicationBankId } = useParams();
  // const { data: applicationBank } = useGetApplicationDataToBankQuery(
  //   Number(applicationBankId)
  // );
  // const dataTable =
  //   applicationBank?.scoring_result.data.creditworthiness
  //     ?.businessTrendAssessment;

  // const [updateConclusion, { isLoading: isUpdateConclusionLoading }] =
  //   useUpdateCreditWorthinessConclusionMutation();

  // const [form] = useForm();

  // Подставляем initialValues в форму, когда появляются результаты выполнения запроса
  // useLayoutEffect(() => {
  //   if (applicationBank) {
  //     form.resetFields();
  //   }
  // }, [applicationBank, form]);

  const handleClick = () => {
    downloadJudgment({
      applicationBankId: Number(applicationBankId),
    });
  };

  // const handleUpdateConclusion = () => {
  //   updateConclusion({
  //     applicationBankId: Number(applicationBankId),
  //     body: {
  //       commentProfessionalJudgment: form.getFieldValue(
  //         "commentProfessionalJudgment"
  //       ),
  //     },
  //   });
  // };
  // const initialValues = {
  //   commentProfessionalJudgment:
  //     applicationBank?.scoring_result.data.commentProfessionalJudgment,
  // };

  // const columns = [
  //   {
  //     dataIndex: "title",
  //     key: "number",
  //     width: "60%",
  //   },
  //   {
  //     dataIndex: "value",
  //     key: "number",
  //   },
  // ];

  // const dataSource = dataTable?.map((row) => {
  //   return { ...row, key: row.title };
  // });

  return (
    <>
      <Alert
        type={"success"}
        message="Сформировать профсуждение"
        description="Документ с комментариями"
        action={
          <Button type={"primary"} onClick={() => handleClick()}>
            Сформировать документ
          </Button>
        }
      />

      {/* <Divider orientation={"left"} orientationMargin={0}>
        Блок формирования профсуждения
      </Divider>

      <Text className={classes.tableTitle}>
        Оценка тенденций в деятельности
      </Text>
      <Table
        showHeader={false}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered={true}
      />

      <Form form={form} initialValues={initialValues}>
        {applicationBank && (
          <CommentForm
            name={"commentProfessionalJudgment"}
            title={"Заключение:"}
            disabled={
              applicationBank?.modified_bank_status.type ===
              APPLICATION_BANK_STATUS.NEW_APPLICATION
            }
          />
        )}
        <Button
          type={"primary"}
          onClick={() => handleUpdateConclusion()}
          loading={isUpdateConclusionLoading}
        >
          Сохранить
        </Button>
      </Form> */}
    </>
  );
};
